// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2D2GG","col":"styles_col__2OZnv","fulfillmentStatus":"styles_fulfillmentStatus__2bZ9j","emailCol":"styles_emailCol__Y3OUA"};